import { REDUX } from 'constants/'
import { ROUTES_NAMES } from 'constants/name.routes'
import { IListOfSectorAndLocations } from 'pages/Configurations/Users/Children/UnitySectorColum'
import {
    UserReducerTypeInitiator,
    UserAction,
    UserReducer,
    UserServiceNow,
    userProfiles,
    TypeTableColums,
    IUserServiceNowV2
} from 'types/user'

const mapUserToTableColumn = (user: IUserServiceNowV2): TypeTableColums => {
    const locations: IListOfSectorAndLocations[] = user.u_locations?.map(
        (location) => ({
            locationId: location.sys_id,
            locationName: location.name,
            locationSectors: location.sectors.map((sector) => sector.name)
        })
    )

    return {
        link: `${ROUTES_NAMES.configurationsRoutes.accessUser}/${user.u_user_id}`,
        u_user: user.name,
        listOfSectorAndLocations: locations,
        u_profile: user.u_profile,
        u_location: '',
        u_sector: '',
        'u_user.email': user.u_user_email,
        u_active: user.u_active
    }
}

const getUniqueUsersBySysId = (
    users: IUserServiceNowV2[] = []
): IUserServiceNowV2[] =>
    Array.from(
        new Map(users.map((user) => [user.sys_id, user])).values()
    )

/**
 * Reducer para objeto user
 * @param state
 * @param action
 */
const UserReducers = (
    state = UserReducerTypeInitiator,
    action: UserAction
): UserReducer => {
    switch (action.type) {
        case REDUX.reducers.GET_ALL_USERS:
            return {
                ...state,
                userProfiles: userProfiles,
                usersList: action.payload,
                error: false,
                loading: false
            } as UserReducer
        case REDUX.reducers.GET_ALL_USERS_V2:
            return {
                ...state,
                userProfiles: userProfiles,
                usersList: action.payload,
                usersListDataTable: action.payload?.map(mapUserToTableColumn),
                error: false,
                loading: false
            } as UserReducer
        case REDUX.reducers.GET_ALL_USERS_COUNT:
            return {
                ...state,
                userAllCount: action.payload,
                error: false,
                loading: false
            } as UserReducer
        case REDUX.reducers.GET_CURRENT_USER:
            return {
                ...state,
                user: action.payload,
                error: false,
                loading: false
            } as UserReducer
        case REDUX.reducers.GET_PAGINATED_USERS_WITH_LOCATIONS_AND_SECTORS: {
            const uniqueUsers = getUniqueUsersBySysId(action.payload)

            return {
                ...state,
                userProfiles: userProfiles,
                usersList: uniqueUsers,
                usersListDataTable: uniqueUsers.map(mapUserToTableColumn),
                error: false,
                loading: false
            } as UserReducer
        }
        default:
            return state
    }
}

export default UserReducers
